<template>
  <svg 
    width="17" 
    height="17" 
    viewBox="0 0 17 17" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M13.4583 15.375L8.49996 11.8333L3.54163 15.375V4.04167C3.54163
      3.66594 3.69088 3.30561 3.95656 3.03993C4.22223 2.77426 4.58257
      2.625 4.95829 2.625H12.0416C12.4173 2.625 12.7777 2.77426 13.0434
      3.03993C13.309 3.30561 13.4583 3.66594 13.4583 4.04167V15.375Z"
      stroke="currentColor"
      stroke-width="2" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
  </svg>
</template>
